module.exports = __webpack_public_path__ + "static/media/congratulations.d7590b69.png";